import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

interface ScrollRevealProps {
  children: React.ReactNode;
  direction?: 'up' | 'down' | 'left' | 'right' | 'fade';
  delay?: number;
  duration?: number;
  className?: string;
}

const ScrollReveal: React.FC<ScrollRevealProps> = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.6,
  className = ''
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const getInitialValues = () => {
    const initial: any = { opacity: 0 };
    if (direction === 'up') initial.y = 50;
    if (direction === 'down') initial.y = -50;
    if (direction === 'left') initial.x = 50;
    if (direction === 'right') initial.x = -50;
    return initial;
  };

  const getAnimateValues = () => ({
    opacity: 1,
    y: 0,
    x: 0
  });

  return (
    <motion.div
      ref={ref}
      initial={getInitialValues()}
      animate={isInView ? getAnimateValues() : getInitialValues()}
      transition={{
        duration,
        delay,
        ease: "easeOut"
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
